import { getFormattedDate } from "../../utils/getFormattedDate";


export const FechaComponente = ({ lang = 'es' }) => {
    const fecha = new Date(); // Ejemplo de fecha fija
    return <div>{getFormattedDate(fecha, lang)}</div>;
};

